import { render } from "./Contact_page.vue?vue&type=template&id=1f5ecc3a&scoped=true"
import script from "./Contact_page.vue?vue&type=script&lang=js"
export * from "./Contact_page.vue?vue&type=script&lang=js"

import "./Contact_page.vue?vue&type=style&index=0&id=1f5ecc3a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1f5ecc3a"

export default script